import { observer } from "mobx-react-lite/dist"
import { useProposalsEditRecipientsStore } from "./ProposalsEditRecipientsStore"
import CreateClientAutocomplete from "features/clients/create/CreateClientAutocomplete"

export default observer(function ProposalsEditRecipientsSelectClient() {
   const proposalsEditRecipientsStore = useProposalsEditRecipientsStore()

   return proposalsEditRecipientsStore.formHandler.advisorClientId.bindInput(ip => <CreateClientAutocomplete {...ip} label="Select a client*" />)
})
